import { CourseDef } from '../../../../types';
import L2079370 from './2079370';
import L2079371 from './2079371';
import L2079372 from './2079372';
import L4313038 from './4313038';
import L4313051 from './4313051';
// import L5234476 from './5234476';
import L5234477 from './5234477';

export const estrategiasOTC: CourseDef = {
  courseTitle: 'ESTRATÉGIAS DE OTC',
  lessons: [L2079370, L2079371, L2079372, L4313038, L4313051, 
    // L5234476, 
    L5234477],
};

